import { BsShieldLockFill } from 'react-icons/bs';
import { HiArrowCircleRight } from 'react-icons/hi';

import Button from '@/tayara-kit/Button';
import FeedbackMessage from '@/tayara-kit/FeedbackMessage';
import Input from '@/tayara-kit/Input';
import Text from '@/tayara-kit/Text';

import LoginScaffold from './LoginScaffold';

export interface NewPasswordScreenProps {
  password: string;
  setPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  clickConnexion: () => void;
  error: string;
}

const NewPasswordScreen = ({
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  clickConnexion,
  error,
}: NewPasswordScreenProps) => (
  <LoginScaffold>
    {error ? <FeedbackMessage text={error} /> : <></>}

    <div className="card-body px-0">
      <Text
        text="Créer votre nouveau mot de passe"
        as="h3"
        className="mb-4 font-medium text-xl text-gray-700"
      />
      <Text
        text="Mot de passe (Obligatoire)"
        as="label"
        className="text-xs text-gray-700 font-light"
      />
      <Input
        type="password"
        startIcon={BsShieldLockFill}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Text
        text="Confirmer le mot de passe (Obligatoire)"
        as="label"
        className="text-xs text-gray-700 font-light mt-4"
      />
      <Input
        type="password"
        startIcon={BsShieldLockFill}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
    </div>

    {/* Actions */}
    <div className="card-actions items-center grid grid-cols-12 gap-x-3 mb-16">
      {/* <span className="col-span-4 flex items-center space-x-3 text-gray-700 font-light text-sm">
        <input
          type="checkbox"
          className="checkbox checkbox-primary checkbox-xs"
          value="eyeh"
          id="stay-connected"
        />
        <label htmlFor="stay-connected">Rester connecté</label>
      </span> */}

      <Button
        aria-label="Connexion"
        className="btn-primary col-start-8 col-span-5"
        icon={<HiArrowCircleRight size={20} />}
        onClick={clickConnexion}
      >
        Confirmer
      </Button>
    </div>
  </LoginScaffold>
);

export default NewPasswordScreen;
